<template>
  <div>
    <CCard>
      <Device ref="deviceView" @change="onChangedSite" prefix="watek_"/>
    </CCard>

    <Event ref="eventView" @click="onClickEvent" prefix="watek_"/>

    <EventDialog ref="eventDialog" />
  </div>
</template>

<script>
import Dashboard from "@/views/btfs/Dashboard"

export default {
  name: "WatekDashboard",
  extends: Dashboard
};
</script>
